import api from './api';

/**
 * Rate Zone Mileage support client. The flat quote.ratezonemileage table is edited
 * grouped by rate zone (each "record" is a zone + its mileage tiers).
 */
export interface MileageTier {
  recno: number; // 0 for an unsaved new tier
  miles: string;
  ratetype: string;
  mileagerate: string;
}

export interface ZoneOption {
  value: string;
  label: string;
}

const base = '/ratezone-mileage';

const ratezoneMileageService = {
  /** Rate zones with no tiers yet — the choices when creating a new record. */
  async unusedZones(signal?: AbortSignal): Promise<ZoneOption[]> {
    const res = await api.get(`${base}/unused-zones`, { signal });
    return res.data as ZoneOption[];
  },

  async getLines(ratezone: string, signal?: AbortSignal): Promise<{ ratezone: string; lines: MileageTier[] }> {
    const res = await api.get(`${base}/lines`, { params: { ratezone }, signal });
    return res.data as { ratezone: string; lines: MileageTier[] };
  },

  async save(body: { ratezone: string; deletes: number[]; lines: MileageTier[] }): Promise<{ ratezone: string }> {
    const res = await api.put(`${base}/save`, body);
    return res.data as { ratezone: string };
  },

  /** Edit-history endpoint for a whole zone (passed to EditHistoryLink). */
  historyEndpoint(ratezone: string): string {
    return `${base}/history?ratezone=${encodeURIComponent(ratezone)}`;
  },
};

export default ratezoneMileageService;
